module.exports = __webpack_public_path__ + "front/img/6-1.c0de7072.png";